import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { BoxTitle } from '../../PageTemplate';
import { Img } from '../../../helper';
import './qrcode.scss';

class Qrcode extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventID: null,
            qrcode: "",
            url: "",
            downloadLink: null,
            name: ""
        }
    }

    static getDerivedStateFromProps(props, state) {
        const eventID = props.events.currentEventID;

        if(eventID !== state.eventID) {
            return {
                eventID: eventID
            }
        }

        if(eventID && props.events.list && props.events.list[eventID]) {
            const eventData = props.events.list[eventID];
            return {
                qrcode: eventData.website.qrcode,
                url: eventData.website.url,
                name: eventData.name            
            }
        }
    }

    download() {
        const size = 1000;
        Img.svgToImage(this.state.qrcode, (url) => {
            if(!this.state.downloadLink) {
                this.setState({downloadLink: url});
            }
        }, {
            x: size,
            y: size,
            // for now disabled draw link on bottom of qrcode image
            text: false, //this.state.url,
            fontSize: null //"60"
        });
    }

    render() {
        if(this.state.qrcode && !this.state.downloadLink) this.download();

        return (
            <div id="qrcode">
                <BoxTitle icon="faQrcode">
                    ברקוד האירוע
                </BoxTitle>
                <div dangerouslySetInnerHTML={{__html: this.state.qrcode}} />
                <a className="qrcodeLink" href={this.state.url} target="_blank">{this.state.url}</a>
                <div className="buttons">
                    <a className="btn qrcodeLink" href={this.state.downloadLink} download={this.state.name}>
                        להורדה
                    </a>
                    <Link to={`/events/${this.state.eventID}/qrcode`} target="_blank" className="btn qrcodeLink">
                        להדפסה
                    </Link>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer
    }
}

const QrcodeWithRedux = connect(mapStateToProps)(Qrcode);

export {QrcodeWithRedux as Qrcode};


// WEBPACK FOOTER //
// ./src/components/EventPage/qrcode/Qrcode.jsx